import * as THREE from 'three';
import type { WeatherVisualState } from '../../weather/weather-types.js';

export class WeatherEffects {
  private rain: THREE.Points;
  private rainVel: Float32Array;
  private foliage: THREE.Object3D[] = [];
  private state: WeatherVisualState = {
    mood: 'clear',
    windKmh: 0,
    rainIntensity: 0,
    effectsEnabled: true,
  };

  constructor(parent: THREE.Group, patioCenter: THREE.Vector3) {
    const count = 220;
    const geo = new THREE.BufferGeometry();
    const pos = new Float32Array(count * 3);
    this.rainVel = new Float32Array(count);
    for (let i = 0; i < count; i += 1) {
      pos[i * 3] = patioCenter.x + (Math.random() - 0.5) * 11;
      pos[i * 3 + 1] = 2 + Math.random() * 5;
      pos[i * 3 + 2] = patioCenter.z + (Math.random() - 0.5) * 14;
      this.rainVel[i] = 6 + Math.random() * 4;
    }
    geo.setAttribute('position', new THREE.BufferAttribute(pos, 3));
    this.rain = new THREE.Points(
      geo,
      new THREE.PointsMaterial({
        color: 0xaaccff,
        size: 0.08,
        transparent: true,
        opacity: 0,
        depthWrite: false,
      }),
    );
    parent.add(this.rain);
  }

  registerFoliage(mesh: THREE.Object3D): void {
    this.foliage.push(mesh);
  }

  setVisualState(next: WeatherVisualState): void {
    this.state = next;
  }

  tick(dt: number, t: number): void {
    const mat = this.rain.material as THREE.PointsMaterial;
    const targetOpacity =
      this.state.effectsEnabled && this.state.rainIntensity > 0.05 ? this.state.rainIntensity * 0.55 : 0;
    mat.opacity = THREE.MathUtils.lerp(mat.opacity, targetOpacity, 1 - Math.pow(0.001, dt));

    if (mat.opacity > 0.02) {
      const attr = this.rain.geometry.attributes.position as THREE.BufferAttribute;
      for (let i = 0; i < this.rainVel.length; i += 1) {
        let y = attr.getY(i) - this.rainVel[i] * dt * (0.8 + this.state.rainIntensity);
        if (y < 0.1) {
          y = 5 + Math.random() * 2;
          attr.setX(i, 10 + (Math.random() - 0.5) * 11);
          attr.setZ(i, 2 + (Math.random() - 0.5) * 14);
        }
        attr.setY(i, y);
      }
      attr.needsUpdate = true;
    }

    const wind = this.state.effectsEnabled ? this.state.windKmh : 0;
    const sway = Math.min(0.12, wind * 0.004);
    for (let i = 0; i < this.foliage.length; i += 1) {
      const m = this.foliage[i];
      m.rotation.z = Math.sin(t * 1.2 + i) * sway;
      m.rotation.x = Math.cos(t * 0.9 + i * 0.7) * sway * 0.6;
    }
  }

  dispose(): void {
    this.rain.geometry.dispose();
    (this.rain.material as THREE.Material).dispose();
  }
}
